import React from 'react';
import Can from "../Can";
import ReqExamLabPage from "./ReqExamLabPage";

function ReqExamLab(props) {
    var myHome;

    if (!props.apiAuthGroups) {
        myHome = (
            null
        )
    } else {
        myHome = (
            <Can
                role={props.apiAuthGroups}
                perform="labExamRequest-page:visit"
                yes={() => (
                    <ReqExamLabPage
                        apiAuthResponse={props.apiAuthResponse}
                        apiAuthName={props.apiAuthName}
                        apiAuthSurname={props.apiAuthSurname}
                        apiAuthGroups={props.apiAuthGroups}
                        labVersion={props.labVersion}
                    />
                )}
                no={() => (null)}
            />
        )
    }


    return myHome;
}

export default ReqExamLab;